export default __webpack_public_path__ + "static/media/looksrare.513bf7df.png";